export default __webpack_public_path__ + "static/media/no-data-found.16d3772e.svg";